<div class="fixed top-5 right-5 z-[1000] space-y-4">
  @for (alert of alerts(); track alert.id) {

  <div
    class="alert-enter w-80 min-h-[80px] bg-opacity-95 shadow-lg rounded-lg p-4 flex items-center space-x-2 transition-transform relative"
    [ngClass]="{
      'bg-green-50 text-green-600 border-l-4 border-green-600':
        alert.type === 'success',
      'bg-red-50 text-red-600 border-l-4 border-red-500':
        alert.type === 'error',
      'bg-yellow-50 text-yellow-600 border-l-4 border-yellow-500':
        alert.type === 'warning',
      'bg-blue-50 text-blue-600 border-l-4 border-blue-500':
        alert.type === 'info'
    }"
  >
    <!-- Línea lateral de color según el tipo de alerta -->
    <div
      class="w-1 absolute top-0 left-0 rounded-l-lg"
      [ngClass]="{
        'bg-green-600': alert.type === 'success',
        'bg-red-600': alert.type === 'error',
        'bg-yellow-600': alert.type === 'warning',
        'bg-blue-600': alert.type === 'info'
      }"
      style="height: 100%"
    ></div>

    <!-- Ícono de la alerta -->
    <div class="flex-shrink-0">
      @if (alert.type === 'success') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill-rule="evenodd"
          d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm4.707 7.293a1 1 0 0 0-1.414-1.414L10 13.172l-1.293-1.293a1 1 0 1 0-1.414 1.414L10 16l6.707-6.707Z"
          clip-rule="evenodd"
        />
      </svg>
      } @if (alert.type === 'error') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill-rule="evenodd"
          d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm7.707-3.707a1 1 0 0 0-1.414 1.414L10.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414L12 13.414l2.293 2.293a1 1 0 0 0 1.414-1.414L13.414 12l2.293-2.293a1 1 0 0 0-1.414-1.414L12 10.586 9.707 8.293Z"
          clip-rule="evenodd"
        />
      </svg>
      } @if (alert.type === 'warning') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          fill-rule="evenodd"
          d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0V8Zm-1 7a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z"
          clip-rule="evenodd"
        />
      </svg>
      } @if (alert.type === 'info') {
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6"
        fill="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm0 18.75a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm0-4h-1.5V6h3v8.75h-1.5z"
        />
      </svg>
      }
    </div>

    <!-- Mensaje de la alerta -->
    <div class="flex-1 break-words">
      <h3 class="font-semibold">
        {{ getTitle(alert.type) }}:
        <span class="font-normal">{{ alert.message }}</span>
      </h3>
    </div>

    <!-- Botón de cierre -->
    <button
      class="text-gray-500 hover:text-gray-600 focus:outline-none flex-shrink-0 ml-2"
      aria-label="Cerrar"
      (click)="closeAlert(alert.id!)"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-5 h-5"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>
  }
</div>
